import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import {isEmpty} from 'lodash';
import {Bar} from 'react-chartjs-2';
import 'chart.piecelabel.js';
import Switch from "react-switch";
import {IoCaretDownOutline, IoCaretUp } from "react-icons/io5";
import {BsChevronContract} from "react-icons/bs";

import {getPermission, getUser} from '../../utils/TokenManager';
import {ADMIN_DASHBOARD} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";
import MessageModal from "../staffData/MessageModal";
import ActivityLog from "./ActivityLog";
import CorrectionLog from  "../staffData/CorrectionsLog" ;


const agencyData = {
    labels: ['LY Actual', 'TY Goal', 'TY Actual'],
    datasets: [
        {
            label: 'Agency Data',
            borderWidth: 1,
            data: [],
            backgroundColor: [
                'rgba(200, 200, 200, 0.7)', 'rgba(85, 150, 217, 0.7)', 'rgba(132, 190, 68, 0.7)' 
            ],
            hoverBackgroundColor: [
                'rgba(200, 200, 200, 1)', 'rgba(85, 150, 217, 1)', 'rgba(132, 190, 68, 1)'
            ]
        }
    ]
};
const options = {
    maintainAspectRatio: true,
    scales: {
        xAxes: [{
            barThickness : 50,
        }],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                        return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                        return '$' + value;
                    }
                }
            }
        }]
    },
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                try {
                    return (" " + data.datasets[tooltipItem.datasetIndex].label + ": $ " 
                    + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                    }));
                } catch(error) {
                    return tooltipItem.yLabel;
                }
            }
        }
    },
    legend: {
        display: false
    },
    plugins: {
        datalabels: {
            display: false
        }
    }
}
const MANAGE_USER_URL = "/user-profile";
const PTO_URL = "/pto";
const STAFF_DATA_URL = "/staff-data";

export default class AdminHome extends Component {
    state = {
        sortType : '',
        userList: [],
        isLoading: false,
        performanceScore: {},
        loginStatus: {},
        kpiCorrections: {},
        recognition: {},
        currentMonthGoal: 0,
        selectedUser: {},
        ptoRequestStatus: {},
        openMessageModal: false,
        openActivityModal: false,
        allLocationFilter: 1,
        isCorrectionLogOpen: false
    };

    auth = {
		user: getUser(),
		permission: getPermission()[ADMIN_DASHBOARD]
	}

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
            this.intervalId  = setInterval(this.getInitialState, 60000);
        }
    
    };

    getInitialState = async () => {
        if (! parseInt(this.props.defaultAgencyProfile.profileId)) {
            try {
                await this.props.getDefaultAgencyProfile(this.props.agencyLocation);
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
        let {allLocationFilter} = this.state;
        const {locationList} = this.props;
        if (locationList.length > 1 && allLocationFilter) {
            allLocationFilter = 1;
        } else {
            allLocationFilter = 0;
        }
        await this.getUserList(allLocationFilter);
        this.getPerformanceScore(allLocationFilter);
        this.getRevenueTarget();
        this.getLoginStatus(allLocationFilter);
        this.getUserRecognitionList(allLocationFilter);
        this.getPTORequestStatus(allLocationFilter);
    };

    getUserList = async (allLocation=1) => {
        try {
            let result = await this.props.getUserList(
                this.props.agencyLocation, allLocation
            );
            if (result) {
                let userList = result.map(user => ({...user}));
                this.setState({userList});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    }

    toggleAllLocationFilter = () => {
		this.setState((prevState) => ({
			allLocationFilter: prevState.allLocationFilter ? 0 : 1
        }), async () => {
            let {allLocationFilter} = this.state;
            const {locationList} = this.props;
            if (locationList.length > 1 && allLocationFilter) {
                allLocationFilter = 1;
            } else {
                allLocationFilter = 0;
            }
            await this.getUserList(allLocationFilter);
            this.getPerformanceScore(allLocationFilter);
            this.getLoginStatus(allLocationFilter);
            this.getUserRecognitionList(allLocationFilter);
            this.getPTORequestStatus(allLocationFilter);
        });
    }
    
    componentWillUnmount = () => {
       clearInterval(this.intervalId);
    }

    getPerformanceScore = async(allLocation=1) => {
        if (this.auth.permission.can_view) {
            this.setState({isLoading: true});
            try {
                let result = await this.props.getPerformanceScores(
                    this.props.agencyLocation, allLocation
                );
                if (result) {
                    let performanceScore = {...result};
                    this.setState({performanceScore});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
            this.setState({isLoading: false});
        }
    };

    getRevenueTarget = async() => {
        if (this.auth.permission.can_view) {
            if (this.props.defaultAgencyProfile.profileId) {
                try {
                    let result = await this.props.getRevenueTarget(
                        this.props.defaultAgencyProfile.profileId
                    );
                    if (result) {
                        let revenueTarget = result.map(target => ({...target}));
                        let currentMonth = moment().format("MMMM");
                        let currentMonthGoal = 0, tyActualTotal = 0, tyGoalTotal = 0, lyActualTotal = 0;
                        let flag = true;
                        revenueTarget.map((target) => {
                            if (flag) {
                                tyActualTotal += target.ty_actual;
                                tyGoalTotal += target.ty_planned;
                                lyActualTotal += target.ly_actual;
                            }
                            if (target.month_name === currentMonth) {
                                currentMonthGoal = target.ty_target;
                                flag = false;
                            }
                        });
                        agencyData.datasets[0].data = [lyActualTotal, tyGoalTotal, tyActualTotal];
                        this.setState({currentMonthGoal});
                    }
                } catch (error) {
                    toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
                }
            } else {
                agencyData.datasets[0].data = [0, 0, 0];
                console.log("No Agency Profile selected.")
            }
        }
    };

    getLoginStatus = async(allLocation=1) => {
        if (this.auth.permission.can_view) {
            try {
                let result = await this.props.getLoginStatus(
                    this.props.agencyLocation, allLocation=1
                );
                if (result) {
                    let loginStatus = {...result};
                    this.setState({loginStatus});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    };

    getPTORequestStatus = async(allLocation=1) => {
        if (this.auth.permission.can_view) {
            try {
                let result = await this.props.getPTORequestStatus(
                    this.props.agencyLocation, allLocation
                );
                if (result) {
                    this.setState({ptoRequestStatus: {...result}});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    };

    getUserRecognitionList = async(allLocation=1) => {
        if (this.auth.permission.can_view) {
            try {
                let result = await this.props.getUserRecognitionList(
                    this.props.agencyLocation, allLocation
                );
                if (result) {
                    let recognition = {...result};
                    this.setState({recognition});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    };

    selectUser = (user) => {
        let userList = this.state.userList.map(userObj => {
            let UpdatedUser = {...userObj};
            if (userObj.id === user.id) {
                if (UpdatedUser.is_selected) {
                    UpdatedUser['is_selected'] = false;
                    this.setState({selectedUser: {}});
                } else {
                    UpdatedUser['is_selected'] = true;
                    this.setState({selectedUser: {...user}});
                    
                }
            } else {
                UpdatedUser['is_selected'] = false;
            }
            console.log('user',UpdatedUser);
            return UpdatedUser;
            
        });
        this.setState({userList});
    };

    openMessageModal = () => {
        const {selectedUser} = this.state;
        if (selectedUser.id > 0) {
            this.setState({openMessageModal: true});
        } else {
            toast.error("Please select a user.");
        }
    }

    toggleMessageModal = () => {
        this.setState(prevState => ({openMessageModal: !prevState.openMessageModal}));
    }

    openActivityModal = () => {
        this.setState({openActivityModal: true});
    }

    toggleActivityModal = () => {
        this.setState(prevState => ({openActivityModal: !prevState.openActivityModal}));
    }

    openCorrectionLogModal = () => {
        this.setState({isCorrectionLogOpen: true});
    }

    toggleCorrectionLogModal = () => {
        this.setState({isCorrectionLogOpen: false});  
        this.getUserList();
        
    }
    onsort = (sortType) => {
        const {userList} = this.state;
        const {performanceScore} = this.state;
        const sorted = userList.sort( (a, b ) => {
            const isReversed = (sortType === 'asc')? 1 : -1;
            if (performanceScore.user_score && sortType != ''){
                console.log(isReversed) 
            return isReversed * ((performanceScore.user_score[a.full_name]?performanceScore.user_score[a.full_name]:0) - (performanceScore.user_score[b.full_name]?performanceScore.user_score[b.full_name]:0)) 
            }   
            else{
                return 1 * a.full_name.localeCompare(b.full_name)
            }   
        });
        this.setState({userList :sorted, sortType}); 
    }
    
    
    render() {
        const {
            userList, sortType, performanceScore, currentMonthGoal, 
            loginStatus, openMessageModal, selectedUser, openActivityModal, 
            recognition, ptoRequestStatus, isLoading, allLocationFilter, isCorrectionLogOpen
        } = this.state;
        const {locationList} = this.props;
        let tableRows = userList.map((user, index) => (
            <tr key={index}  
                className={`cursor-pointer ${user.is_selected ? "bg-info text-white" : ""}`} 
                onClick={() => this.selectUser(user)}
            >
                <td className="align-middle">
                    <Link to={`${MANAGE_USER_URL}#?userId=${user.id}`} 
                        className="user-link"
                    >
                        {user.full_name}
                    </Link>
                </td>
                <td className="text-center align-middle">
                    {!(isEmpty(performanceScore)) &&  !(isEmpty(performanceScore.user_score)) 
                    && user.full_name in performanceScore.user_score ? 
                        <NumberFormat value={performanceScore.user_score[user.full_name]} 
                        displayType={'text'} thousandSeparator={true} 
                        decimalScale={2} fixedDecimalScale={true} /> 
                        : ''
                    } 
                </td>
                <td className="text-center py-0 align-middle">
                    {!(isEmpty(loginStatus)) ? 
                        loginStatus[user.full_name] ? 
                            <i className="fa fa-check-circle text-success font-20"></i>
                            : ''
                        : ''
                    }
                </td>
                <td className="text-center align-middle">
                    {user.correction_pending > 0 ?                    
                        <a onClick={this.openCorrectionLogModal} >{user.correction_pending}</a>               
                        : null
                    }
                </td>
                <td className="text-center align-middle">
                    {!(isEmpty(ptoRequestStatus)) && ptoRequestStatus[user.full_name] ? 
                        <Link to={`${PTO_URL}#?form=1`} 
                            className="user-link text-info px-1"
                        >
                            {ptoRequestStatus[user.full_name]}
                        </Link>
                        : null
                    }
                </td>
                <td className="text-center align-middle">
                    {!(isEmpty(recognition)) ? 
                        recognition[user.full_name] ? 
                            recognition[user.full_name]
                            : ''
                        : ''
                    }
                </td>
            </tr>
        ));

        return (
            <div className="row">
                <div className="col-sm-8">
                    {this.auth.permission.can_view ?
                        <div className="main-dashboard-col">
                            <div className="d-flex justify-content-between align-items-center">
                                <label className="bg-primary text-white py-1 px-2 font-16 width-300">
                                    <span className="float-left">Agency should have score: </span>
                                    <span className="font-18 box-text-shadow float-right font-weight-bold">
                                        {!(isEmpty(performanceScore)) ? 
                                            <NumberFormat value={performanceScore.agency_should_have} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} fixedDecimalScale={true} />
                                            : '0.00'
                                        }
                                    </span>
                                </label>
                                <div className="d-flex align-items-center">
                                <label className="bg-score text-white py-1 px-2 font-16 width-300">
                                    <span className="float-left">Agency Evaluation Score: </span>
                                    <span className="font-18 box-text-shadow float-right font-weight-bold">
                                        {!(isEmpty(performanceScore)) ? 
                                            <NumberFormat value={performanceScore.agency_avg_score} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} fixedDecimalScale={true} />
                                            : '0.00'
                                        }
                                    </span>
                                </label>
                                <label className="d-flex justify-content-right">
                                    <a className="text-info px-2 cursor-pointer" 
                                        onClick={this.openActivityModal} 
                                        title="Open Activity Log"
                                    > 
                                        <span className="fa fa-download font-16"></span>
                                    </a>
                                    <a className="text-info cursor-pointer"
                                        onClick={this.openMessageModal} title="Send Message"
                                    > 
                                        <span className="fa fa-envelope font-16"></span>
                                    </a>
                                </label>
                                </div>
                                
                            </div>
                            <Table striped bordered size="sm" className="mb-0">
                                <thead className="bg-f5">
                                    <tr>
                                        <th className="font-weight-bold">
                                            Staff Name
                                            <br/>
                                            {locationList.length > 1 &&
                                                <label className="mb-0 font-13">
                                                    <Switch 
                                                        onChange={this.toggleAllLocationFilter} 
                                                        checked={Boolean(allLocationFilter)} 
                                                        className="react-switch"
                                                        name="all_location"
                                                        height={17}
                                                        width={36}
                                                    />
                                                    <span>All Locations</span>
                                                </label>
                                            }
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            Current 
                                            <br/>Score
                                            {sortType == '' ?
                                                 <a href='#' className="button ml-2" onClick={()=>this.onsort('asc')}><BsChevronContract/></a>
                                                  :
                                                sortType == 'asc' ?
                                                <a href='#' className="button ml-2" onClick={()=>this.onsort('desc')}><IoCaretUp/></a> 
                                                :
                                                <a href='#' className="button ml-2" onClick={()=>this.onsort('')}><IoCaretDownOutline/></a>  
                                            } 
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            Login <br/>Status
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            Correction <br/>Requests
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            PTO <br/>Requests
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            Recognition
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr></tr>
                                    {tableRows}
                                </tbody>
                            </Table>
                            {isLoading && 
                                <p className="loading-gif">
                                    <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                                </p>
                            }
                        </div>
                        : 
                        <div className="main-dashboard-col">
                            <p className="text-center">
                                Access Denied
                            </p>
                        </div>
                    }
                </div>
                <div className="col-sm-4 text-center pl-sm-0">
                    {this.auth.permission.can_view ?
                        <div className="main-dashboard-col">
                            <label className="bg-goal text-white py-1 px-2 font-16 width-300">
                                <span className="float-left">Current Month Goal: </span>
                                <span className="font-18 box-text-shadow float-right font-weight-bold">
                                    <NumberFormat value={currentMonthGoal} displayType={'text'} 
                                    thousandSeparator={true} prefix={'$ '} />
                                </span>
                            </label>
                            <Bar
                                data={agencyData}
                                options={options}
                                width={100} height={75}
                            />
                        </div>
                        : <div className="main-dashboard-col">
                            <p className="text-center">
                                Access Denied
                            </p>
                        </div>
                    }
                </div>
                {openMessageModal &&
                    <MessageModal {...this.props} 
                        modal={openMessageModal} 
                        toggleModal={this.toggleMessageModal} 
                        selectedUser={selectedUser} 
                    />
                }
                {openActivityModal &&
                    <ActivityLog {...this.props} 
                        modal={openActivityModal} 
                        toggleModal={this.toggleActivityModal} 
                    />
                }
                {isCorrectionLogOpen && 
                    <CorrectionLog {...this.props} 
                        modal={isCorrectionLogOpen}
                        toggleModal={this.toggleCorrectionLogModal}
                        selectedUser={selectedUser} 
                    />
                }
            </div>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/adminHome/AdminHome.js